/* EuroFloat's own in-browser PDF writer, copied unchanged from the live Colour Builder (EuroFloatPdfPage / EuroFloatPdfDocument). */
(function(){
  class EuroFloatPdfPage {
    constructor(document) {
      this.document = document;
      this.commands = [];
      this.images = new Set();
    }

    number(value) {
      return Number(value || 0).toFixed(2).replace(/\.00$/, '');
    }

    colour(value) {
      return value.map((part) => Math.max(0, Math.min(1, Number(part || 0))).toFixed(3)).join(' ');
    }

    text(value, x, top, size = 11, options = {}) {
      const safe = this.document.escapeText(value);
      if (!safe) return;
      const font = options.bold ? 'F2' : 'F1';
      const colour = options.colour || [0.11, 0.11, 0.12];
      const y = this.document.height - top - (size * .84);
      const estimatedWidth = safe.length * size * (options.bold ? .56 : .52);
      const textX = options.align === 'right' ? x - estimatedWidth : (options.align === 'center' ? x - (estimatedWidth / 2) : x);
      this.commands.push(`BT /${font} ${this.number(size)} Tf ${this.colour(colour)} rg 1 0 0 1 ${this.number(textX)} ${this.number(y)} Tm (${safe}) Tj ET`);
    }

    wrap(value, x, top, width, size = 10, lineHeight = 14, options = {}) {
      const lines = this.document.wrapText(value, width, size, options.bold);
      lines.forEach((line, index) => this.text(line, x, top + (index * lineHeight), size, options));
      return lines.length * lineHeight;
    }

    fillRect(x, top, width, height, colour) {
      const y = this.document.height - top - height;
      this.commands.push(`${this.colour(colour)} rg ${this.number(x)} ${this.number(y)} ${this.number(width)} ${this.number(height)} re f`);
    }

    strokeRect(x, top, width, height, colour = [.86, .86, .88], lineWidth = 1) {
      const y = this.document.height - top - height;
      this.commands.push(`${this.colour(colour)} RG ${this.number(lineWidth)} w ${this.number(x)} ${this.number(y)} ${this.number(width)} ${this.number(height)} re S`);
    }

    line(x1, top1, x2, top2, colour = [.86, .86, .88], lineWidth = 1) {
      const y1 = this.document.height - top1;
      const y2 = this.document.height - top2;
      this.commands.push(`${this.colour(colour)} RG ${this.number(lineWidth)} w ${this.number(x1)} ${this.number(y1)} m ${this.number(x2)} ${this.number(y2)} l S`);
    }

    circle(cx, topCy, radius, fill, stroke = null, lineWidth = 1) {
      const cy = this.document.height - topCy;
      const k = radius * .5522847498;
      const path = [
        `${this.number(cx + radius)} ${this.number(cy)} m`,
        `${this.number(cx + radius)} ${this.number(cy + k)} ${this.number(cx + k)} ${this.number(cy + radius)} ${this.number(cx)} ${this.number(cy + radius)} c`,
        `${this.number(cx - k)} ${this.number(cy + radius)} ${this.number(cx - radius)} ${this.number(cy + k)} ${this.number(cx - radius)} ${this.number(cy)} c`,
        `${this.number(cx - radius)} ${this.number(cy - k)} ${this.number(cx - k)} ${this.number(cy - radius)} ${this.number(cx)} ${this.number(cy - radius)} c`,
        `${this.number(cx + k)} ${this.number(cy - radius)} ${this.number(cx + radius)} ${this.number(cy - k)} ${this.number(cx + radius)} ${this.number(cy)} c`
      ].join(' ');
      if (stroke) this.commands.push(`${this.colour(fill)} rg ${this.colour(stroke)} RG ${this.number(lineWidth)} w ${path} B`);
      else this.commands.push(`${this.colour(fill)} rg ${path} f`);
    }

    tick(cx, topCy, scale = 1, colour = [1, 1, 1]) {
      const y = this.document.height - topCy;
      this.commands.push(`${this.colour(colour)} RG ${this.number(1.8 * scale)} w ${this.number(cx - 4 * scale)} ${this.number(y)} m ${this.number(cx - 1 * scale)} ${this.number(y - 3 * scale)} l ${this.number(cx + 5 * scale)} ${this.number(y + 4 * scale)} l S`);
    }

    image(name, x, top, width, height) {
      this.images.add(name);
      const y = this.document.height - top - height;
      this.commands.push(`q ${this.number(width)} 0 0 ${this.number(height)} ${this.number(x)} ${this.number(y)} cm /${name} Do Q`);
    }
  }

  class EuroFloatPdfDocument {
    constructor() {
      this.width = 595.28;
      this.height = 841.89;
      this.pages = [];
      this.images = new Map();
      this.encoder = new TextEncoder();
    }

    addImage(image) {
      if (!image || !image.bytes || !image.bytes.length) return '';
      const name = `Im${this.images.size + 1}`;
      this.images.set(name, image);
      return name;
    }

    addPage(draw) {
      const page = new EuroFloatPdfPage(this);
      draw(page);
      this.pages.push(page);
      return page;
    }

    safeText(value) {
      return String(value == null ? '' : value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[\u2018\u2019]/g, "'")
        .replace(/[\u201c\u201d]/g, '"')
        .replace(/[\u2013\u2014]/g, '-')
        .replace(/\u2026/g, '...')
        .replace(/[^\x20-\x7E]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    escapeText(value) {
      return this.safeText(value).replace(/([\\()])/g, '\\$1');
    }

    wrapText(value, width, size, bold = false) {
      const text = this.safeText(value);
      if (!text) return [];
      const average = size * (bold ? .56 : .52);
      const maximum = Math.max(8, Math.floor(width / average));
      const words = text.split(/\s+/);
      const lines = [];
      let current = '';
      words.forEach((word) => {
        const candidate = current ? `${current} ${word}` : word;
        if (candidate.length <= maximum) {
          current = candidate;
          return;
        }
        if (current) lines.push(current);
        if (word.length <= maximum) {
          current = word;
          return;
        }
        let remaining = word;
        while (remaining.length > maximum) {
          lines.push(remaining.slice(0, maximum));
          remaining = remaining.slice(maximum);
        }
        current = remaining;
      });
      if (current) lines.push(current);
      return lines;
    }

    bytes(value) {
      return typeof value === 'string' ? this.encoder.encode(value) : value;
    }

    toBlob() {
      const images = [...this.images.entries()];
      const imageIds = new Map();
      let nextId = 5;
      images.forEach(([name]) => imageIds.set(name, nextId++));
      const pageRefs = this.pages.map(() => ({ page: nextId++, content: nextId++ }));
      const objectCount = nextId - 1;
      const objects = new Array(objectCount + 1);

      objects[1] = [this.bytes('<< /Type /Catalog /Pages 2 0 R >>')];
      objects[2] = [this.bytes(`<< /Type /Pages /Kids [${pageRefs.map((ref) => `${ref.page} 0 R`).join(' ')}] /Count ${pageRefs.length} >>`)];
      objects[3] = [this.bytes('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>')];
      objects[4] = [this.bytes('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>')];

      images.forEach(([name, image]) => {
        const id = imageIds.get(name);
        objects[id] = [
          this.bytes(`<< /Type /XObject /Subtype /Image /Width ${image.width} /Height ${image.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${image.bytes.length} >>\nstream\n`),
          image.bytes,
          this.bytes('\nendstream')
        ];
      });

      this.pages.forEach((page, index) => {
        const refs = pageRefs[index];
        const usedImages = [...page.images].filter((name) => imageIds.has(name));
        const imageResource = usedImages.length
          ? `/XObject << ${usedImages.map((name) => `/${name} ${imageIds.get(name)} 0 R`).join(' ')} >>`
          : '';
        objects[refs.page] = [this.bytes(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${this.width} ${this.height}] /Resources << /Font << /F1 3 0 R /F2 4 0 R >> ${imageResource} >> /Contents ${refs.content} 0 R >>`)];
        const content = this.bytes(page.commands.join('\n'));
        objects[refs.content] = [this.bytes(`<< /Length ${content.length} >>\nstream\n`), content, this.bytes('\nendstream')];
      });

      const chunks = [];
      const offsets = new Array(objectCount + 1).fill(0);
      let length = 0;
      const push = (chunk) => {
        const bytes = this.bytes(chunk);
        chunks.push(bytes);
        length += bytes.length;
      };

      push('%PDF-1.4\n%EFPDF\n');
      for (let id = 1; id <= objectCount; id += 1) {
        offsets[id] = length;
        push(`${id} 0 obj\n`);
        (objects[id] || []).forEach(push);
        push('\nendobj\n');
      }
      const xrefOffset = length;
      push(`xref\n0 ${objectCount + 1}\n`);
      push('0000000000 65535 f \n');
      for (let id = 1; id <= objectCount; id += 1) push(`${String(offsets[id]).padStart(10, '0')} 00000 n \n`);
      push(`trailer\n<< /Size ${objectCount + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`);
      return new Blob(chunks, { type: 'application/pdf' });
    }
  }
  window.EFPdf={Doc:EuroFloatPdfDocument};
})();
